import type { FilterFieldType, Operator } from '@/stores'

const OPERATORS: Record<string, Operator[]> = {
  number: [
    { value: 'equals', label: 'Equals' },
    { value: 'not_equals', label: 'Does not equal' },
    { value: 'greater_than', label: 'Greater than' },
    { value: 'greater_than_or_equal', label: 'Greater than or equal' },
    { value: 'less_than', label: 'Less than' },
    { value: 'less_than_or_equal', label: 'Less than or equal' },
    { value: 'between', label: 'Between' },
  ],
  date: [
    { value: 'equals', label: 'Equals' },
    { value: 'not_equals', label: 'Does not equal' },
    { value: 'before', label: 'Before' },
    { value: 'after', label: 'After' },
    { value: 'between', label: 'Between' },
  ],
  text: [
    { value: 'contains', label: 'Contains' },
    { value: 'not_contains', label: 'Does not contain' },
    { value: 'equals', label: 'Equals' },
    { value: 'not_equals', label: 'Does not equal' },
    { value: 'starts_with', label: 'Starts with' },
    { value: 'ends_with', label: 'Ends with' },
  ],
  select: [
    { value: 'in', label: 'Is' },
    { value: 'not_in', label: 'Is not' },
  ],
}

const DEFAULT_OPERATOR = {
  number: 'equals',
  date: 'equals',
  select: 'in',
  text: 'contains',
}

export function getDefaultOperators(type: FilterFieldType): Operator[] {
  const operators = OPERATORS[type] || OPERATORS.text
  return [...operators]
}

export const getDefaultOperator = (type: FilterFieldType): string =>
  DEFAULT_OPERATOR[type] || DEFAULT_OPERATOR.text
